import React, { Component } from 'react'
import { GetData } from '../../../api/service'
import { Typography, Table, TableHead, TableRow, TableCell, TableBody, Button } from '@material-ui/core'
import Edit from '@material-ui/icons/Edit'

export default class ActivityLanding extends Component {
    state = {
        list: [],
        isLoaded: false
    }

    componentDidMount() {
        GetData(`/${this.props.apikey}/getactivity`)
            .then((resp) => {
                this.setState({
                    list: resp,
                    isLoaded: true
                })
            })
    }

    render() {
        return (
            <div>
                <Typography variant="h6">
                    Activities
            </Typography>

                <div align="right">
                    <Button variant="contained" color="primary" onClick={() => this.props.history.push('/activity/add')}>
                        Add Activity
            </Button>
                </div>
                <br />
                <Table size="small" style={{backgroundColor: '#fff'}}>

                    <TableHead>
                        <TableRow>
                            <TableCell width="5%">#</TableCell>
                            <TableCell width="15%">Type</TableCell>
                            <TableCell width="15%">Dept Code</TableCell>
                            <TableCell width="10%">Year</TableCell>
                            <TableCell width="65%">Activity</TableCell>

                            <TableCell width="5%">Edit</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {this.state.list.map((el, index) =>
                            <TableRow key={index} style={{ verticalAlign: 'top' }}>
                                <TableCell>{index + 1}</TableCell>
                                <TableCell>{el.type}</TableCell>
                                <TableCell>{el.dept_code}</TableCell>
                                <TableCell>{el.year}</TableCell>
                                <TableCell dangerouslySetInnerHTML={{ __html: el.activity }}></TableCell>


                                <TableCell><Edit onClick={() => this.props.history.push('/activity/edit', el)} /></TableCell>
                            </TableRow>
                        )}
                    </TableBody>

                </Table>


            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/Components/Department/Activity/ActivityLanding.js